import { isA2uiV08BotReplyPayload } from './isA2uiV08BotReplyPayload';

/**
 * 與 `useChatHistoryWithAdvancedSync` 之 `normalizeMessage` 同步：寫入本地前附加 `isA2uiV08BotReply`。
 * @param {Record<string, unknown>} normalizedMessage
 * @param {Record<string, unknown>} originalMessage
 */
export function attachPersistA2uiV08(normalizedMessage, originalMessage) {
  if (originalMessage.sender === 'chatbot' || originalMessage.sender === 'rocketChat') {
    return {
      ...normalizedMessage,
      isA2uiV08BotReply: isA2uiV08BotReplyPayload(originalMessage),
    };
  }
  const next = { ...normalizedMessage };
  delete next.isA2uiV08BotReply;
  return next;
}
